import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import { PdfParams } from 'app/core/models/user-manual/UserManual.model';
import { ToastService } from 'app/core/services/toast.service';
import { UserManualService } from 'app/core/services/user-manual.service';
import { MessageType } from 'app/shared/constants';
import { Utils } from '../../core/utils';

@UntilDestroy()
@Component({
  template: `<div class="flex justify-content-center align-items-center" *ngIf="!loading; else load">
      <pdf-viewer
        *ngIf="pdfSrc"
        [src]="pdfSrc"
        [render-text]="true"
        [original-size]="true"
        [fit-to-page]="true"
        style="height: 100vh; width: 100%"
      ></pdf-viewer>
      <div class="w-full h-screen" *ngIf="!pdfSrc"></div>
    </div>
    <ng-template #load>
      <div class="flex justify-content-center align-items-center h-screen">
        <p-progressSpinner></p-progressSpinner>
      </div>
    </ng-template>`,
})
export class UserManualComponent implements OnInit {
  pdfSrc: string = '';
  pdfParams: PdfParams | null = null;
  loading = true;
  constructor(
    public route: ActivatedRoute,
    private router: Router,
    private userManualService: UserManualService,
    private toastService: ToastService,
    private translate: TranslateService,
  ) {
    this.route?.queryParams?.pipe(untilDestroyed(this)).subscribe(async (res) => {
      this.pdfParams = new PdfParams({ ...res });
    });
  }

  async ngOnInit() {
    if (this.pdfParams) {
      try {
        const doc = window.document.getElementsByClassName('grecaptcha-badge').item(0);
        if (doc) {
          (doc as HTMLElement).style.visibility = 'hidden';
        }
        const stream = await this.userManualService.getPdf(this.pdfParams);
        if (stream && stream?.body) {
          this.pdfSrc = await Utils.fileToDataUrl(stream.body);
        } else {
          console.error(stream);
          this.toastService.showToast(MessageType.ERROR, this.translate.instant('TOAST.GENERAL_ERROR'));
        }
      } catch (error) {
        console.error(error);
        const msg = (() => {
          if (error.statusCode == 404 || error.status == 404) return this.translate.instant('SERV_ERR.RESOURCE_NOT_FOUND');
          else return this.translate.instant('TOAST.GENERAL_ERROR');
        })();
        this.toastService.showToast(MessageType.ERROR, msg);
        if (error.statusCode == 404 || error.status == 404) this.router.navigate(['/not-found'], { replaceUrl: true });
      } finally {
        this.loading = false;
      }
    }
    this.loading = false;
  }
}
